<div class="w-full h-full skeleton-loader {{ border_radius_class }} {{ additional_class }}" ></div> 